import React from "react";
import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const footerSections = [
  { title: "Explore", links: [["Home", "/"], ["How It Works", "/about"], ["About Us", "/about-us"]] },
  { title: "Rankings", links: [["Men's Rankings", "/rankings/men"], ["Women's Rankings", "/rankings/women"]] },
  { title: "Tools", links: [["Equivalent Performances", "/scoring"], ["Feedback", "/feedback"], ["Privacy Policy", "/privacy"]] },
];

const Footer = () => (
  <Box sx={{ backgroundColor: "#071b33", color: "#ffffff", borderTop: "4px solid #c92520", mt: 4, px: { xs: 3, md: 6 }, py: 3.5 }}>
    <Box sx={{ maxWidth: 1180, mx: "auto", display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "1.35fr repeat(3, minmax(0, 1fr))" }, gap: 3 }}>
      <Stack spacing={1.1} sx={{ gridColumn: { xs: "1 / -1", md: "auto" } }}>
        <Box
          sx={{
            position: "relative",
            width: 235,
            height: 72,
            overflow: "hidden",
            bgcolor: "#ffffff",
            borderRadius: 2,
          }}
        >
          <Box
            component="img"
            src="/images/nytrax-full-logo.png"
            alt="NYTRAX — National Youth Track Athlete Index"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "104%",
              height: "auto",
              maxWidth: "none",
              transform: "translate(-50%, -50%)",
            }}
          />
        </Box>
        <Typography sx={{ color: "#b8c4d1", fontSize: 12, maxWidth: 260 }}>National Youth Track Athlete Index</Typography>
      </Stack>
      {footerSections.map((section) => (
        <Stack key={section.title} spacing={0.7}>
          <Typography sx={{ color: "#ef4136", fontWeight: 950, fontSize: 12, letterSpacing: 1, textTransform: "uppercase" }}>{section.title}</Typography>
          {section.links.map(([label, path]) => (
            <MuiLink key={path} component={Link} to={path} underline="hover" sx={{ color: "#ffffff", fontWeight: 700, width: "fit-content" }}>
              {label}
            </MuiLink>
          ))}
        </Stack>
      ))}
    </Box>
  </Box>
);

export default Footer;
